import isString from './isString.js';

/**
 * Update Vuex store state
 * @param {object} store Vuex instance
 * @param {object} cart Response from Checkout API
 * @param {object} cart.account MyAccount details
 * @param {object} cart.customer Customer details
 * @param {object} cart.form Form details
 * @param {object} cart.payment Payment details
 * @param {object} cart.order Order details
 * @param {object} cart.providerAccount Shopper details
 * @param {object} cart.retargetingUrl Retargeting URL
 */
export default (store, cart) => {
	store.commit('SET_ACCOUNT', cart.account);
	store.commit('SET_CUSTOMER', cart.customer);
	store.commit('SET_FORM', Object.assign({}, cart.form, {
		defaultCountry: cart.geoIpCountry, // @todo Will be moved into "form" right from the API response
		taxIdentifier: cart.taxIdentifier // @todo Will be moved into "form" right from the API response
	}));
	store.commit('SET_ORDER', cart.order);
	store.commit('SET_PAYMENT', cart.payment);
	store.commit('SET_PROVIDER_ACCOUNT', cart.providerAccount);
	store.commit('SET_RETARGETING_URL', cart.retargetingUrl);
	if (isString(cart.form?.initial?.companyName, 1) || isString(cart.form?.initial?.nationalId, 14)) {
		store.commit('SET_COMPANY', true);
	}
};
